'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTapAndPlay = function MdTapAndPlay(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 1.7q1.3 0 2.3 1t0.9 2.3v28.4q0 1.3-0.9 2.3t-2.3 0.9h-3.6q-0.2-3.3-1.5-6.6h5.1v-21.6h-16.8v10q-1.9-0.9-3.2-1.1v-12.3q0-1.3 0.9-2.3t2.3-1.1z m-25 18.3q7.5 0 12.9 5.4t5.3 13h-3.2q0-6.2-4.5-10.6t-10.5-4.4v-3.4z m0 13.4q2 0 3.5 1.4t1.5 3.6h-5v-5z m0-6.8q4.8 0 8.2 3.5t3.4 8.3h-3.4q0-3.5-2.4-5.9t-5.8-2.5v-3.4z' })
        )
    );
};

exports.default = MdTapAndPlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/tap-and-play.js
// module id = 1262
// module chunks = 0